import { replace } from 'react-router-redux';
import { reset } from 'redux-form';

import apiInitiateVoteRegistration from '../../utils/voteRegistration/voteRegistrationInitiateApi';
import apiUpdateVoteRegistration from '../../utils/voteRegistration/voteRegistrationUpdateApi';
import apiCompleteVoteRegistration from '../../utils/voteRegistration/voteRegistrationCompleteApi';

import getLocalRepresentative from '../../utils/localRepresentative/getLocalRepresentative';
import { SET_LOCAL_REPRESENTATIVE } from '../LocalRep/actions';

import { onFinishMultiAction } from '../Widget/actions';

export const VOTE_REGISTRATION_SUCCESS = 'VOTE_REGISTRATION_SUCCESS';
export const VOTE_REGISTRATION_INITIATED = 'VOTE_REGISTRATION_INITIATED';
export const VOTE_REGISTRATION_UNSUCCESS = 'VOTE_REGISTRATION_UNSUCCESS';
export const VOTE_REGISTRATION_COMPLETED = 'VOTE_REGISTRATION_COMPLETED';
export const VOTE_REGISTRATION_CANCELED = 'VOTE_REGISTRATION_CANCELED';
export const SET_SUCCESS_INFO_VOTE = 'SET_SUCCESS_INFO_VOTE';
export const SET_DATE = 'SET_DATE';
export const SHOW_ADDRESS_POPUP = 'SHOW_ADDRESS_POPUP';
export const SHOW_ERROR_POPUP = 'SHOW_ERROR_POPUP';
export const ON_POSTAL_CODE_CHANGE = 'ON_POSTAL_CODE_CHANGE';
export const ON_POSTAL_CODE_FORM_CHANGE = 'ON_POSTAL_CODE_FORM_CHANGE';
export const SAVE_FORM = 'SAVE_FORM';
export const VOTE_REGISTRATION_REGISTER_ONLINE = 'VOTE_REGISTRATION_REGISTER_ONLINE';
export const IS_SUBMITTING = 'IS_SUBMITTING';
export const IS_BACK_TRANSITION = 'IS_BACK_TRANSITION';

export const onShowAddressPopup = (
    value,
    actionIdentifier,
    actionInitiated
) => dispatch => {
    dispatch({
        type: SHOW_ADDRESS_POPUP,
        payload: value
    });

    if (!value) {
        dispatch({
            type: VOTE_REGISTRATION_CANCELED,
            payload: actionIdentifier
        });
    }

    if (!actionInitiated) {
        dispatch({
            type: VOTE_REGISTRATION_INITIATED,
            payload: actionIdentifier
        });
    }
};

export const onAddressSubmit = (
    apiRequestData,
    values,
    id,
    state,
    localRepLoaded,
    isPostalCodeChanged,
    actionIdentifier,
    isMultiActionsCard
) => dispatch => {
    dispatch({
        type: VOTE_REGISTRATION_UNSUCCESS,
        payload: { isAddressSubmitting: true }
    });

    let userMonth;
    switch (values.month) {
        case 'Jan':
            userMonth = 0;
            break;
        case 'Feb':
            userMonth = 1;
            break;
        case 'Mar':
            userMonth = 2;
            break;
        case 'Apr':
            userMonth = 3;
            break;
        case 'May':
            userMonth = 4;
            break;
        case 'Jun':
            userMonth = 5;
            break;
        case 'Jul':
            userMonth = 6;
            break;
        case 'Aug':
            userMonth = 7;
            break;
        case 'Sep':
            userMonth = 8;
            break;
        case 'Oct':
            userMonth = 9;
            break;
        case 'Nov':
            userMonth = 10;
            break;
        case 'Dec':
            userMonth = 11;
            break;
        default:
            break;
    }

    const year = values.year;
    const day = values.day;
    let month = values.month;
    const dateOfBirth = values.day + '-' + values.month + '-' + values.year;

    dispatch({
        type: SET_DATE,
        payload: { month, day, year }
    });

    month = userMonth;
    const userDate = new Date(parseInt(year, 10) + 18, month, day);
    const today = new Date();

    if (today.getTime() - userDate.getTime() < 0) {
        dispatch({
            type: SET_SUCCESS_INFO_VOTE,
            payload: { reason: 'underAge', actionIdentifier }
        });

        if (isMultiActionsCard) {
            onFinishMultiAction(actionIdentifier)(dispatch);
        } else {
            dispatch(replace('/voteRegistration/unsuccess'));
        }

        dispatch({
            type: VOTE_REGISTRATION_UNSUCCESS,
            payload: { isAddressSubmitting: false }
        });
    } else {
        if (!localRepLoaded || isPostalCodeChanged) {
            return getLocalRepresentative(values.postalCode)
                .then(data => {
                    dispatch({
                        type: SET_LOCAL_REPRESENTATIVE,
                        payload: data
                    });

                    initiateVoteRegistration(
                        apiRequestData,
                        id,
                        data.address.state,
                        dateOfBirth,
                        dispatch,
                        actionIdentifier,
                        isMultiActionsCard
                    );
                })
                .catch(() => {
                    dispatch({
                        type: SET_SUCCESS_INFO_VOTE,
                        payload: { reason: 'stateNotAvailable', actionIdentifier }
                    });

                    if (isMultiActionsCard) {
                        onFinishMultiAction(actionIdentifier)(dispatch);
                    } else {
                        dispatch(replace('/voteRegistration/unsuccess'));
                    }
                });
        } else {
            initiateVoteRegistration(
                apiRequestData,
                id,
                state,
                dateOfBirth,
                dispatch,
                actionIdentifier,
                isMultiActionsCard
            );
        }
    }
};

const initiateVoteRegistration = (
    apiRequestData,
    id,
    state,
    dateOfBirth,
    dispatch,
    actionIdentifier,
    isMultiActionsCard
) => {
    apiInitiateVoteRegistration(apiRequestData, id, state, dateOfBirth)
        .then(data => {
            dispatch({
                type: SHOW_ADDRESS_POPUP,
                payload: false
            });

            if (data.isMailRegistrationAvailable) {
                dispatch(replace('/voteRegistration/step1'));
            } else {
                dispatch({
                    type: SET_SUCCESS_INFO_VOTE,
                    payload: { reason: 'stateNotAvailable', actionIdentifier }
                });

                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else {
                    dispatch(replace('/voteRegistration/unsuccess'));
                }
            }

            dispatch({
                type: SET_SUCCESS_INFO_VOTE,
                payload: { ...data, actionIdentifier }
            });

            dispatch({
                type: VOTE_REGISTRATION_UNSUCCESS,
                payload: { isAddressSubmitting: false }
            });
        })
        .catch(() => {
            dispatch({
                type: VOTE_REGISTRATION_UNSUCCESS,
                payload: { isAddressSubmitting: false, isErrorOnSubmit: true }
            });

            setTimeout(() => {
                dispatch({
                    type: VOTE_REGISTRATION_UNSUCCESS,
                    payload: { isErrorOnSubmit: false }
                });
            }, 4000);
        });
};

export const onGoToStep = (
    step,
    direction,
    apiRequestData,
    answerId,
    previouSteps,
    formData,
    actionIdentifier,
    isMultiActionsCard,
    actionCompletedTime
) => dispatch => {
    dispatch({
        type: SHOW_ADDRESS_POPUP,
        payload: false
    });

    if (direction === 'back') {
        dispatch({
            type: IS_BACK_TRANSITION,
            payload: true
        });
    } else {
        dispatch({
            type: IS_SUBMITTING,
            payload: true
        });
    }

    if (step === 0) {
        dispatch(replace('/voteRegistration'));

        setTimeout(() => {
            if (direction === 'back') {
                dispatch({
                    type: IS_BACK_TRANSITION,
                    payload: false
                });
            } else {
                dispatch({
                    type: IS_SUBMITTING,
                    payload: false
                });
            }
        }, 1000);
    } else if (step === 'success') {
        dispatch({
            type: VOTE_REGISTRATION_REGISTER_ONLINE,
            payload: { isRegisterOnlineSubmitting: true }
        });

        apiCompleteVoteRegistration(
            apiRequestData,
            answerId,
            formData,
            true,
            null,
            null,
            actionCompletedTime
        ).then(data => {
            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else {
                dispatch(replace('/voteRegistration/success'));
            }

            dispatch({
                type: VOTE_REGISTRATION_REGISTER_ONLINE,
                payload: { isRegisterOnlineSubmitting: false }
            });

            dispatch({
                type: SET_SUCCESS_INFO_VOTE,
                payload: { ...data, reason: 'isRegisterOnline', actionIdentifier }
            });

            dispatch({
                type: VOTE_REGISTRATION_COMPLETED,
                payload: actionIdentifier
            });

            setTimeout(() => {
                if (direction === 'back') {
                    dispatch({
                        type: IS_BACK_TRANSITION,
                        payload: false
                    });
                } else {
                    dispatch({
                        type: IS_SUBMITTING,
                        payload: false
                    });
                }
            }, 1000);
        });
    } else {
        if (previouSteps) {
            if (formData.changeOfAddress && previouSteps.includes(7)) {
                dispatch(replace('/voteRegistration/step7'));
            } else if (formData.changeOfName && previouSteps.includes(6)) {
                dispatch(replace('/voteRegistration/step6'));
            } else if (formData.hasMailingAddress && previouSteps.includes(5)) {
                dispatch(replace('/voteRegistration/step5'));
            } else {
                dispatch(replace('/voteRegistration/step4'));
            }
        } else {
            dispatch(replace(`/voteRegistration/step${step}`));
        }

        setTimeout(() => {
            if (direction === 'back') {
                dispatch({
                    type: IS_BACK_TRANSITION,
                    payload: false
                });
            } else {
                dispatch({
                    type: IS_SUBMITTING,
                    payload: false
                });
            }
        }, 1000);
    }
};

export const onPostalCodeChange = () => dispatch => {
    dispatch({
        type: ON_POSTAL_CODE_CHANGE,
        payload: true
    });
};

export const sendForm = (
    values,
    apiRequestData,
    answerId,
    formData,
    isMultiActionsCard,
    actionIdentifier
) => dispatch => {
    dispatch({
        type: VOTE_REGISTRATION_SUCCESS,
        payload: { isFormSubmitting: true }
    });

    apiCompleteVoteRegistration(apiRequestData, answerId, formData, false, values, true)
        .then(data => {
            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else {
                dispatch(replace('/voteRegistration/successFinal'));
            }

            dispatch({
                type: VOTE_REGISTRATION_COMPLETED,
                payload: actionIdentifier
            });

            dispatch({
                type: VOTE_REGISTRATION_SUCCESS,
                payload: { isFormSubmitting: false }
            });

            dispatch({
                type: SET_SUCCESS_INFO_VOTE,
                payload: { ...data, reason: 'isRegisterComplete', actionIdentifier }
            });
        })
        .catch(data => {
            dispatch({
                type: VOTE_REGISTRATION_SUCCESS,
                payload: { isFormSubmitting: false }
            });

            dispatch({
                type: SHOW_ERROR_POPUP,
                payload: {
                    ...data,
                    showErrorPopup: true
                }
            });

            dispatch(reset('errorForm'));
        });
};

export const saveForm = (
    values,
    nextSteps,
    apiRequestData,
    formData,
    id,
    answerId,
    addressSource,
    isFinalStep,
    actionIdentifier,
    isMultiActionsCard,
    actionCompletedTime
) => dispatch => {
    dispatch({
        type: SAVE_FORM,
        payload: values
    });

    if (nextSteps.length) {
        dispatch({
            type: IS_SUBMITTING,
            payload: true
        });

        const element = formData ? formData : values;
        if (element.hasMailingAddress && nextSteps.includes(5)) {
            dispatch(replace('/voteRegistration/step5'));
        } else if (element.changeOfName && nextSteps.includes(6)) {
            dispatch(replace('/voteRegistration/step6'));
        } else if (element.changeOfAddress && nextSteps.includes(7)) {
            dispatch(replace('/voteRegistration/step7'));
        } else if (nextSteps.includes(8)) {
            dispatch(replace('/voteRegistration/step8'));
        } else {
            dispatch(replace('/voteRegistration/step8'));
        }

        setTimeout(() => {
            dispatch({
                type: IS_SUBMITTING,
                payload: false
            });
        }, 1000);
    }

    if (isFinalStep) {
        dispatch({
            type: SAVE_FORM,
            payload: values
        });

        dispatch({
            type: VOTE_REGISTRATION_SUCCESS,
            payload: { isFormSubmitting: true }
        });

        apiCompleteVoteRegistration(
            apiRequestData,
            answerId,
            formData,
            false,
            values,
            null,
            actionCompletedTime
        )
            .then(data => {
                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else {
                    dispatch(replace('/voteRegistration/successFinal'));
                }

                dispatch({
                    type: VOTE_REGISTRATION_SUCCESS,
                    payload: { isFormSubmitting: false }
                });

                dispatch({
                    type: SET_SUCCESS_INFO_VOTE,
                    payload: { ...data, reason: 'isRegisterComplete', actionIdentifier }
                });
            })
            .catch(data => {
                dispatch({
                    type: VOTE_REGISTRATION_SUCCESS,
                    payload: { isFormSubmitting: false }
                });

                dispatch({
                    type: SHOW_ERROR_POPUP,
                    payload: {
                        ...data,
                        showErrorPopup: true
                    }
                });
            });

        return;
    }

    if (id) {
        dispatch({
            type: VOTE_REGISTRATION_UNSUCCESS,
            payload: { isAddressSubmitting: true }
        });

        const formValues = { ...values, ...formData };
        return getLocalRepresentative(formValues.postalCode)
            .then(data => {
                dispatch({
                    type: SET_LOCAL_REPRESENTATIVE,
                    payload: data
                });

                apiUpdateVoteRegistration(
                    formValues,
                    apiRequestData,
                    id,
                    answerId,
                    addressSource
                ).then(data => {
                    if (
                        data.isMailRegistrationAvailable &&
                        data.isOnlineRegistrationAvailable
                    ) {
                        dispatch(replace('/voteRegistration/step3'));
                    } else if (
                        data.isMailRegistrationAvailable &&
                        !data.isOnlineRegistrationAvailable
                    ) {
                        dispatch(replace('/voteRegistration/step4'));
                    } else {
                        dispatch({
                            type: SET_SUCCESS_INFO_VOTE,
                            payload: { reason: 'stateNotAvailable', actionIdentifier }
                        });

                        if (isMultiActionsCard) {
                            onFinishMultiAction(actionIdentifier)(dispatch);
                        } else {
                            dispatch(replace('/voteRegistration/unsuccess'));
                        }
                    }

                    dispatch({
                        type: SET_SUCCESS_INFO_VOTE,
                        payload: { ...data, actionIdentifier }
                    });

                    dispatch({
                        type: VOTE_REGISTRATION_UNSUCCESS,
                        payload: { isAddressSubmitting: false }
                    });
                });
            })
            .catch(() => {
                dispatch({
                    type: SET_SUCCESS_INFO_VOTE,
                    payload: { reason: 'stateNotAvailable' }
                });

                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else {
                    dispatch(replace('/voteRegistration/unsuccess'));
                }

                dispatch({
                    type: VOTE_REGISTRATION_UNSUCCESS,
                    payload: { isAddressSubmitting: false }
                });
            });
    }
};



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/actions.js